const SvgScreenIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.04779 13C5.93766 12.5732 6.9399 12.3333 7.99992 12.3333C9.05994 12.3333 10.0622 12.5732 10.952 13M4.53325 10.3333H11.4666C12.5867 10.3333 13.1467 10.3333 13.5746 10.1153C13.9509 9.9236 14.2569 9.61764 14.4486 9.24131C14.6666 8.81349 14.6666 8.25344 14.6666 7.13333V4.2C14.6666 3.0799 14.6666 2.51984 14.4486 2.09202C14.2569 1.71569 13.9509 1.40973 13.5746 1.21799C13.1467 1 12.5867 1 11.4666 1H4.53325C3.41315 1 2.85309 1 2.42527 1.21799C2.04895 1.40973 1.74299 1.71569 1.55124 2.09202C1.33325 2.51984 1.33325 3.0799 1.33325 4.2V7.13333C1.33325 8.25344 1.33325 8.81349 1.55124 9.24131C1.74299 9.61764 2.04895 9.9236 2.42527 10.1153C2.85309 10.3333 3.41315 10.3333 4.53325 10.3333Z"
          stroke="#66C61C"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export default SvgScreenIcon
